import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import type { Locale, LocalizedText } from '../domain/types';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function localized(
  text: LocalizedText,
  locale: Locale,
): { value: string; fallback: boolean } {
  if (locale === 'ar' && text.ar?.trim()) return { value: text.ar, fallback: false };
  return { value: text.de, fallback: locale === 'ar' && !text.ar?.trim() };
}

export function formatNumber(value: number, locale: Locale, maximumFractionDigits = 2): string {
  return new Intl.NumberFormat(locale === 'ar' ? 'ar' : 'de-DE', {
    maximumFractionDigits,
  }).format(value);
}

export function parseLocalizedNumber(value: string): number {
  const arabicDigits = '٠١٢٣٤٥٦٧٨٩';
  const easternDigits = '۰۱۲۳۴۵۶۷۸۹';
  let normalized = value.trim();
  [...arabicDigits].forEach((digit, index) => {
    normalized = normalized.replaceAll(digit, String(index));
  });
  [...easternDigits].forEach((digit, index) => {
    normalized = normalized.replaceAll(digit, String(index));
  });
  normalized = normalized.replace(/\s/g, '').replace(',', '.').replace('٫', '.');
  return Number(normalized);
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
